import { createRootRoute, Outlet, useMatches } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

import { AppFooter } from '@/components/layout/AppFooter'
import { AppHeader } from '@/components/layout/AppHeader'
import { SkipLink, SkipLinkItem } from '@/components/ui/skip-link'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /**
     * A rota é uma tela de mapa: o visualizador ocupa tudo abaixo do
     * cabeçalho, sem rodapé e sem rolagem da página.
     */
    telaDeMapa?: boolean
  }
}

/*
 * Composição de tela: atalhos de teclado, cabeçalho, conteúdo e rodapé.
 *
 * A tela de mapa é a exceção: sem rodapé, e com a altura exata da janela, para
 * que o conteúdo fique com tudo o que sobra abaixo do cabeçalho — é o que dá
 * altura ao mapa sem medida fixa em pixel. Altura exata, e não mínima: numa
 * tela de mapa a página não pode rolar, senão a roda do mouse rola a página
 * fora do canvas e dá zoom sobre ele. O que não cabe rola dentro do próprio
 * painel, e para isso o `main` precisa de `min-h-0` — sem ele, o item flex não
 * encolhe abaixo do conteúdo e empurra a página para baixo. As demais telas
 * têm o rodapé ao pé do conteúdo e rolam normalmente.
 */
export function Layout() {
  const telaDeMapa = useMatches({
    select: (rotas) => rotas.some((rota) => rota.staticData.telaDeMapa === true),
  })

  return (
    <div className={cn('flex flex-col bg-background', telaDeMapa ? 'h-dvh' : 'min-h-dvh')}>
      <SkipLink>
        <SkipLinkItem href="#conteudo" accessKey="1">
          Ir para o conteúdo
        </SkipLinkItem>
      </SkipLink>

      <AppHeader />

      <main id="conteudo" className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>

      {!telaDeMapa && <AppFooter />}
    </div>
  )
}

export const Route = createRootRoute({ component: Layout })
